import(/* webpackMode: "eager", webpackExports: ["RedemptionWebPage"] */ "/opt/buildhome/repo/src/app/[lng]/(main)/_account-web/personal-web.tsx");
